import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import DialogTitleWithCloseIcon from '../../commons/DialogTitleWithCloseIcon'
import Trans, { t } from '../../commons/Translate.js'

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent)

export default function SLDialog(props) {
  return (
    <Dialog onClose={props.handleClose} aria-labelledby="sl-dialog-title" open={props.open}>
      <DialogTitleWithCloseIcon id="sl-dialog-title" onClose={props.handleClose}>
        {t('Supervisionslevel')}
      </DialogTitleWithCloseIcon>
      <DialogContent dividers>
        <ol start={0}>
          <li>
            <Trans code="entrustment_level_0">
              Ich würde den Studierenden bei dieser Tätigkeit <strong>nicht zuschauen</strong> lassen
            </Trans>
          </li>
          <li>
            <Trans code="entrustment_level_1">
              Ich würde den Studierenden diese Tätigkeit <strong>nur beobachten</strong> lassen
            </Trans>
          </li>
          <li>
            <Trans code="entrustment_level_2">
              Ich würde den Studierenden diese Tätigkeit mit <strong>vollständiger direkter Supervision</strong> bzw. der <strong>Möglichkeit zum direkten Eingreifen</strong> übernehmen lassen
            </Trans>
          </li>
          <li>
            <Trans code="entrustment_level_3">
              Ich würde den Studierenden diese Tätigkeit unter <strong>räumlich entfernter Supervision mit direkter Erreichbarkeit und Kontrolle des Ergebnisses</strong> ausführen lassen
            </Trans>
          </li>
          <li>
            <Trans code="entrustment_level_4">
              Ich würde den Studierenden diese Tätigkeit unter <strong>räumlich entfernter Supervision ohne direkte Erreichbarkeit</strong> ausführen lassen
            </Trans>
          </li>
          <li>
            <Trans code="entrustment_level_5">
              Ich würde dem Studierenden zutrauen, diese Tätigkeit unter <strong>voller Verantwortung ohne Supervision durchzuführen und andere in dieser Tätigkeit anzuführen und zu supervidieren</strong>
            </Trans>
          </li>
        </ol>
      </DialogContent>
    </Dialog>
  )
}
